import { SeniorityMethodEnum } from 'types/graphql';

export const TeamMemberTableColumnCount = (
  isMultiLocationTieringFeatureEnabled = false,
  seniorityMethod = SeniorityMethodEnum.years_months_days,
) => {
  const seniorityColumnCount = seniorityMethod === SeniorityMethodEnum.years_months_days ? 3 : 1; // Years, Months, Days vs. Hours
  const rankingColumnCount = 1; // Ranking
  const multiLocationColumnCount = isMultiLocationTieringFeatureEnabled
    ? rankingColumnCount + seniorityColumnCount
    : 0;
  return {
    B2B: 6 + multiLocationColumnCount,
    Agency: 5,
  };
};

export const TeamMemberTableGridColumnWidth = (
  isMultiLocationTieringFeatureEnabled = false,
  seniorityMethod = SeniorityMethodEnum.years_months_days,
) => {
  return {
    B2B: `minmax(332px, 1fr) minmax(167px, 1fr) ${
      isMultiLocationTieringFeatureEnabled ? 'minmax(140px, 1fr) ' : '' //Ranking
    } minmax(232px, 1fr) minmax(202px, 1fr) ${
      isMultiLocationTieringFeatureEnabled
        ? seniorityMethod === SeniorityMethodEnum.years_months_days
          ? `minmax(90px, 1fr) minmax(99px, 1fr) minmax(106px, 1fr) ` //Years, Months, Days
          : `minmax(140px, 1fr) ` //Hours
        : ''
    } minmax(180px, 1fr) minmax(248px, 1fr)`,
    Agency:
      'minmax(332px, 1fr) minmax(167px, 1fr) minmax(232px, 1fr) minmax(180px, 1fr) minmax(248px, 1fr)',
  };
};

export const TeamMemberTablePageSize = 20;
